import { Loading } from '@whistler-ui/k2/components/Loading';
import { Stack } from '@whistler-ui/k2/components/Stack';
import { Paragraph } from '@whistler-ui/k2/components/Typography';
import { useClassHelper } from '@whistler-ui/k2/hooks';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { routes } from '../../../routes';
// Scoped Components
import { TStatuses } from '../../../types';
import { componentName, progressMessages } from '../constants';

interface Props {
  status: TStatuses;
}

export const TestLoader = ({ status }: Props) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const showProgress = pathname.includes(routes.entitlementsTestUseCase.url);
  const c = useClassHelper(componentName);

  return (
    <div className={c('--loading')}>
      <Stack direction="column" gap={4}>
        <Loading />
        {showProgress && <Paragraph>{t(progressMessages[status])}</Paragraph>}
      </Stack>
    </div>
  );
};
